"use client";

import { useEffect, useState } from 'react';
import Link from 'next/link';
import styles from "./Categories.module.css";

type Category = {
  id: string;
  libelle: string;
  description: string | null;
  illustration_path: string | null;
  initiatives_count: number;
};

export default function Categories() {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/public/categories")
      .then(res => (res.ok ? res.json() : []))
      .then(setCategories)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className={styles.zone}>
        <p className={styles.empty}>Chargement…</p>
      </div>
    );
  }

  if (categories.length === 0) {
    return (
      <div className={styles.zone}>
        <p className={styles.empty}>Aucune catégorie publiée</p>
      </div>
    );
  }

  return (
    <div className={styles.zone}>
      <div className={styles.grid}>
        {categories.map((cat) => (
          <Link key={cat.id} href={`/categorie/${cat.id}`} className={styles.card} title={`Voir les initiatives de ${cat.libelle}`}>
            {cat.illustration_path && (
              <img src={cat.illustration_path} alt="" className={styles.illustration} />
            )}
            <div className={styles.cardBody}>
              <h2 className={styles.catName}>
                {cat.libelle}
                <span className={styles.count} title={`${cat.initiatives_count} initiative(s) publiée(s)`}>
                  {cat.initiatives_count}
                </span>
              </h2>
              {cat.description && <p className={styles.desc}>{cat.description}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
